export default {
    gdprLastDocsSignable: state => {
        return state.gdprLastDocs.filter(e=>(e.doc_type===2 || e.doc_type===3))
    },
}
